import { render, staticRenderFns } from "./DaumPost.vue?vue&type=template&id=d154a4a2&scoped=true&"
import script from "./DaumPost.vue?vue&type=script&lang=js&"
export * from "./DaumPost.vue?vue&type=script&lang=js&"
import style0 from "./DaumPost.vue?vue&type=style&index=0&id=d154a4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d154a4a2",
  null
  
)

export default component.exports